import Home from '@/components/common/Home.vue';

export const commonRoutes = {
  path: '/common',
  component: Home,
  name: 'Common',
  redirect: '/common/company',
  meta: {
    title: 'Common',
  },
  children: [
    {
      path: 'company',
      component: () => import('@/views/common/CompanyInfo.vue'),
      meta: {
        title: 'CompanyInfo',
      },
    },
  ],
};
